import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const spotlightAgilityContentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSpotlightAgilityContent: builder.query({
      query: ({
        patientProfileId,
        preferredLanguage,
      }: {
        patientProfileId: number;
        preferredLanguage: string;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Patient/${patientProfileId}/spotlight-agility-content`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetSpotlightAgilityContentQuery } =
  spotlightAgilityContentApi;
export default spotlightAgilityContentApi;
